/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_OpenInputs */

const en_us2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const pt_br2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const es_419_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones`)
};

const pt_pt2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const fr_fr2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const de_de2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen`)
};

const it_it2_coach_extra_conversations_open = /** @type {(inputs: Coach_Extra_Conversations_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazioni`)
};

/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Coach_Extra_Conversations_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_open = /** @type {((inputs?: Coach_Extra_Conversations_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_open(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_open(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_open(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_open(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_open(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_open(inputs)
	return en_us2_coach_extra_conversations_open(inputs)
});
export { coach_extra_conversations_open as "coach-extra.conversations_open" }